// user-agent strings are long and unreadable; reduce one to something a person
// can recognize in a list of their own devices, e.g. "Chrome on iPhone"
export const describeDevice = (userAgent) => {
	if (!userAgent) {
		return "Unknown device"
	}

	const browsers = [
		// order matters — Edge and Chrome both claim "Chrome", and Chrome
		// claims "Safari"
		["Edg/", "Edge"],
		["OPR/", "Opera"],
		["Firefox/", "Firefox"],
		["Chrome/", "Chrome"],
		["Safari/", "Safari"],
	]
	const platforms = [
		["iPhone", "iPhone"],
		["iPad", "iPad"],
		["Android", "Android"],
		["Macintosh", "Mac"],
		["Windows", "Windows"],
		["Linux", "Linux"],
	]

	const match = (pairs) => {
		const found = pairs.find(([needle]) => userAgent.includes(needle))
		return found ? found[1] : null
	}

	const browser = match(browsers)
	const platform = match(platforms)

	if (browser && platform) {
		return `${browser} on ${platform}`
	}
	return browser || platform || "Unknown device"
}

// a coarse "3 hours ago" for the session list — precise enough to spot a
// device you don't recognize, without pulling in a date library
export const describeLastUsed = (date) => {
	if (!date) {
		return "unknown"
	}

	const seconds = Math.floor((Date.now() - new Date(date).getTime()) / 1000)

	if (seconds < 60) return "just now"
	if (seconds < 3600) {
		const minutes = Math.floor(seconds / 60)
		return `${minutes} minute${minutes === 1 ? "" : "s"} ago`
	}
	if (seconds < 86400) {
		const hours = Math.floor(seconds / 3600)
		return `${hours} hour${hours === 1 ? "" : "s"} ago`
	}
	const days = Math.floor(seconds / 86400)
	return `${days} day${days === 1 ? "" : "s"} ago`
}
